import filter from 'lodash/filter';
import map from 'lodash/map';
import result from 'lodash/result';
import find from 'lodash/find';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Label} from '@spothero/ui/backlog';

export default class RadioButtonGroup extends Component {
    static propTypes = {
        className: PropTypes.string,
        /** A unique name which is used to identify this element. If belonging to a form this is used as the key for validation bindings and is required. */
        name: PropTypes.string,
        /** The settings for the contained Radio components. Only one of the items should ever be set to checked at a time. */
        initialItems: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.string,
                checked: PropTypes.bool,
            })
        ).isRequired,
        /** Whether to disable all the Radio items in this group. */
        disabled: PropTypes.bool,
        color: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
        onChange: PropTypes.func,
    };
    static defaultProps = {
        color: 'primary',
    };

    constructor(props) {
        super(props);

        const {initialItems} = props;
        const checked = filter(initialItems, 'checked');

        if (!checked.length || checked.length > 1) {
            throw new Error(
                'A RadioButtonGroup must have one of its items set to checked.'
            );
        }

        this.state = {
            value: checked[0].value,
            items: initialItems,
        };
    }

    _onSelectionChanged = evt => {
        const value = evt.target.value;
        const {onChange} = this.props;
        const {items, value: currentValue} = this.state;

        this.setState({
            value,
            items: map(items, item => {
                item.checked = item.value === value;

                return item;
            }),
        });

        if (onChange && currentValue !== value) {
            onChange({
                value,
                label: result(find(items, {value}), 'label'),
            });
        }
    };

    render() {
        const {name, className, color, disabled} = this.props;
        const {items} = this.state;
        const isSecondary = color === 'secondary';
        const classes = classNames(
            'RadioButtonGroup',
            {'RadioButtonGroup-secondary': isSecondary},
            className
        );
        const buttonClasses = classNames(
            'Button',
            {'Button-secondary': isSecondary},
            {'Button-disabled': disabled}
        );

        return (
            <div className={classes}>
                {items.map((item, i) => {
                    const {checked, label, value} = item;

                    return (
                        <Label key={i}>
                            <input
                                type="radio"
                                name={name}
                                value={value}
                                disabled={disabled}
                                checked={checked}
                                onChange={this._onSelectionChanged}
                            />
                            <span className={buttonClasses}>{label}</span>
                        </Label>
                    );
                })}
            </div>
        );
    }
}
